"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_thin_1 = require("@bryntum/core-thin");
const PulseBryntumGrid_1 = __importDefault(require("@pcs/pulse-components/PulseBryntumGrid"));
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const ticket_history_panel_modules_less_1 = __importDefault(require("./ticket-history-panel.modules.less"));
const ticketHistorySlice_1 = require("../store/ticketHistorySlice");
const TicketHistoryAjaxStore = new core_thin_1.AjaxStore();
const TicketHistoryPanel = (props) => {
    const { ticketId } = props;
    const { data } = (0, react_redux_1.useSelector)((state) => state.ticketHistory);
    const dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useEffect)(() => {
        dispatch((0, ticketHistorySlice_1.fetchTicketHistory)(ticketId));
    }, []);
    TicketHistoryAjaxStore.data = data || [];
    return (react_1.default.createElement("div", { className: ticket_history_panel_modules_less_1.default.ticketHistory__CollapseRoot },
        react_1.default.createElement(PulseBryntumGrid_1.default, { gridProps: {
                animateRemovingRows: false,
                columns: [
                    {
                        field: 'date',
                        text: 'Date / Time',
                        flex: 1,
                    },
                    {
                        field: 'status.name',
                        text: 'Status',
                        flex: 1,
                    },
                    {
                        field: 'user.name',
                        text: 'User',
                        flex: 1,
                    },
                    {
                        field: 'description',
                        text: 'Change/s',
                        flex: 4,
                        htmlEncode: false,
                        cellCls: ticket_history_panel_modules_less_1.default.ticketHistory__descriptionCell,
                    },
                    {
                        type: 'aggregate',
                        text: 'Time Added',
                        flex: 2,
                        renderer: ({ record }) => {
                            const { timesheetHours, timesheetActivity } = record;
                            if (!timesheetHours) {
                                return 'No time added';
                            }
                            return `${timesheetHours} hours logged for ${timesheetActivity}`;
                        },
                    },
                ],
                store: TicketHistoryAjaxStore,
            }, paginate: false })));
};
exports.default = TicketHistoryPanel;
